import { z } from "zod";
/**
 * Safe WhatsApp template display model for UI (create/edit preview, send preview,
 * and outbound conversation bubbles). Display-only — never used to rebuild Graph send.
 */
export const whatsAppTemplatePresentationButtonSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("QUICK_REPLY"),
        text: z.string(),
    }),
    z.object({
        type: z.literal("URL"),
        text: z.string(),
        url: z.string().optional(),
    }),
    z.object({
        type: z.literal("PHONE_NUMBER"),
        text: z.string(),
        phoneNumber: z.string().optional(),
    }),
    z.object({
        type: z.literal("VOICE_CALL"),
        text: z.string(),
    }),
]);
export const whatsAppTemplatePresentationSchema = z.object({
    header: z
        .discriminatedUnion("type", [
        z.object({
            type: z.literal("TEXT"),
            text: z.string(),
        }),
        z.object({
            type: z.literal("IMAGE"),
            /**
             * Short-lived authorized preview URL or local blob URL.
             * Never persist a signed URL as source of truth.
             */
            imageUrl: z.string().min(1).optional(),
            fileName: z.string().optional(),
            missing: z.boolean().optional(),
        }),
    ])
        .optional(),
    body: z.object({
        text: z.string(),
    }),
    footer: z
        .object({
        text: z.string(),
    })
        .optional(),
    buttons: z.array(whatsAppTemplatePresentationButtonSchema).default([]),
});
//# sourceMappingURL=whatsapp-template-presentation.js.map